import styled from "styled-components";

export const Container = styled.div`
	margin: 1rem 0 0 0;
`;

export const TextCenter = styled.div`
	text-align: center;
`;
